import { Icon } from "@material-ui/core"
import ron from './logos/ron.png'
                                       
export const Iconr2 = () => (
    <Icon>
        <img src={ron} />
    </Icon>
)